module.exports = __webpack_public_path__ + "img/рз_18.d0a1459a.png";